<template>
    <footer class="footer-main">
        <div class="footer-content">
            <div class="footer-content-section">
            <div class="footer-menu">
                    <nav>
                        <ul>
                            <li>
                                <router-link class="footer-link-menu" to="/home">Accueil</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/solutions">Solutions</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/services">Services</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/portfolio">Portfolio</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/contact">Contact</router-link>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="footer-center">
                    <img src="./../../assets/logo-footer.png" alt="logo synthes3d footer" />
                    <div class="footer-phone">
                        <span>+33 (0)9</span> 70 66 97 04
                    </div>
                </div> 
                <div class="footer-menu">
                        <ul>
                            <li>
                                <router-link class="footer-link-menu" to="/solutions#vitrine">Site Internet vitrine</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/solutions#boutique">Boutique e-Commerce</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/solutions#appli">Applications Web sur mesure</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/services#secu">Maintenance et sécurité</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/services#seo">Webmarketing & SEO</router-link>
                            </li>
                            <li>
                                <router-link class="footer-link-menu" to="/services#suivi">Suivi d'utilisation de votre site</router-link>
                            </li>
                        </ul>
                </div>
            </div>
        </div>
        <div class="copyright">
            SYNTHES'3D © {{ new Date().getFullYear() }} - Tous droits réservés - <router-link class="footer-link" to="/mentions-legales">Mentions légales</router-link>
        </div>
        
    </footer>
</template>

<script>
export default {
    name: 'TheFooter'   
}
</script>

<style scoped>


.footer-main {
    width:100%;  
    position: relative;
    z-index: 999;
}

.footer-content {    
    width: 100%;;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('./../../assets/bg-footer-sep.png');
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: -55px;
}

.footer-content-section {
    width:100%;
    max-width:1200px;
    display: flex;
    flex-direction: row;
}

.copyright {
    background-image:linear-gradient(to right,#ef4337,#fbab37);
    font-size:15px;
    text-align: center;
    padding:15px 0;
    color:#ffffff;
}

.footer-link {
    text-decoration: none;
    color:#ffffff;
}

.footer-link:hover {
    text-decoration: underline;
}

.footer-menu {
    width:30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.footer-menu ul {
    list-style: none;
}

.footer-menu ul li {
    padding:5px 0;
    position: relative;
}

.footer-menu ul li:before {
    content:'';
    background:#fbab37;
    width:5px;
    height:5px;
    border-radius:50%;
    position: absolute;
    top: 13px;
    left: -14px;
}

.footer-link-menu {
    color:#ffffff;
    font-size:15px;
    text-decoration: none;
}

.footer-link-menu:hover {
    text-decoration: underline;
}


.footer-center {
    width:40%;
    display: flex;
    flex-direction: column;
    align-items: center;    
    padding:75px 0 30px 0;
}

.footer-phone {
    padding-top: 50px;
    color:#ffffff;
    font-size:20px;
}

.footer-phone span {
    color:#fbab37;
}

@media screen and (max-width:767px) {
    .copyright {
        font-size:10px;
    }

    .footer-menu {
        display:none;
    }

    .footer-center {
        width:100%;
        margin: 0 10px;
    }
}
</style>